(function () {
  "use strict";
  if (window.__rvaFlow2) return;
  window.__rvaFlow2 = 1;

  var TBD = "TBD",
    WORD = "(sizes to come)",
    CAT = "/pages/screen-printing-pricing-calculator",
    PLAIN = "/pages/get-a-quote";

  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function money(n) { return typeof window.money === "function" ? window.money(+n || 0) : "$" + (+n || 0).toFixed(2); }
  function count(n, one, many) { return n + " " + (n === 1 ? one : many); }
  function isReq() { return !!$("reqPage"); }
  function St() { return window.S; }
  function warn(e) { try { console.warn("rva-flow2", e); } catch (x) {} }
  function pcs(line) {
    var n = 0;
    (window.SIZES || []).forEach(function (z) { n += +line.sizes[z] || 0; });
    return n;
  }
  function wrap(name, make) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaFlow2) return false;
    var g = make(f);
    for (var k in f) if (Object.prototype.hasOwnProperty.call(f, k)) g[k] = f[k];
    g.rvaFlow2 = 1;
    window[name] = g;
    return true;
  }
  function styleOf(line) { return typeof window.styleById === "function" ? window.styleById(line.id) : null; }
  function upFor(st, z, color) {
    try { return +window.upOf(st, window.SIZES.indexOf(z), color) || 0; } catch (e) { return 0; }
  }
  function hasSize(st, z, color) {
    try { return !!window.hasSz(st, z, color); } catch (e) { return !!(st.sz && st.sz.indexOf(z) >= 0); }
  }
  function photo(st, color, cls) {
    try { return window.photo(st, color, cls); } catch (e) { return ""; }
  }
  function href(st) {
    try { return window.styleHref(st); } catch (e) { return CAT; }
  }
  function total() { try { return window.reqPieces(); } catch (e) { return 0; } }

  function tbdOn() {
    var Z = window.SIZES;
    if (!Array.isArray(Z)) return false;
    if (Z.indexOf(TBD) < 0) Z.push(TBD);
    var w = window.SIZE_WORD;
    if (w && w[TBD] !== WORD) w[TBD] = WORD;
    return true;
  }

  function decode(code) {
    try {
      var t = String(code).split("-").join("+").split("_").join("/");
      while (t.length % 4) t += "=";
      var n = JSON.parse(decodeURIComponent(escape(atob(t))));
      return n && Array.isArray(n[4]) ? n : null;
    } catch (e) { return null; }
  }
  function encode(n) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(n)))).split("+").join("-").split("/").join("_").split("=").join("");
  }
  function applyShared(code) {
    var n = decode(code), S = St();
    if (!n || !S) return false;
    if (!n[4].some(function (r) { return +r[3] > 0; })) return false;
    var out = [];
    n[4].forEach(function (r) {
      var st = typeof window.styleBySid === "function" ? window.styleBySid(+r[0]) : null;
      if (!st || !st.c) return;
      var col = st.c.filter(function (c) { return c[0] === r[1]; })[0];
      if (!col) return;
      var key = st.id + "|" + col[0], tbd = Math.max(0, Math.min(9999, Math.round(+r[3] || 0)));
      var line = S.req.filter(function (l) { return l.key === key; })[0];
      if (line) {
        if (tbd) line.sizes[TBD] = tbd;
        if (out.indexOf(line) < 0) out.push(line);
      } else if (tbd) {
        var sz = {};
        sz[TBD] = tbd;
        out.push({ key: key, id: st.id, color: col, sizes: sz });
      }
    });
    S.req.forEach(function (l) { if (out.indexOf(l) < 0) out.push(l); });
    S.req = out;
    return true;
  }
  function patchShare() {
    wrap("shareURL", function (f) {
      return function () {
        var u = f.apply(this, arguments), S = St();
        try {
          if (!S.req.some(function (l) { return +l.sizes[TBD] > 0; })) return u;
          var m = /#r=([A-Za-z0-9_-]+)/.exec(u), n = m && decode(m[1]);
          if (!n) return u;
          n[4].forEach(function (r, i) {
            var l = S.req[i];
            if (l && +l.sizes[TBD] > 0) r[3] = +l.sizes[TBD];
          });
          return u.replace(m[1], encode(n));
        } catch (e) { return u; }
      };
    });
    wrap("loadShared", function (f) {
      return function (code) {
        var ok = f.apply(this, arguments);
        if (ok) { try { applyShared(code); } catch (e) { warn(e); } }
        return ok;
      };
    });
  }
  function sharedOnLoad() {
    var h = String(window.rvaHash0 || ""), m = /(?:^|[#&])r=([A-Za-z0-9_-]+)/.exec(h);
    if (!m || !isReq()) return;
    var n = decode(m[1]);
    if (!n || !n[4].some(function (r) { return +r[3] > 0; })) return;
    try {
      if (window.loadShared(m[1])) {
        window.render();
        window.saveReq();
      }
    } catch (e) { warn(e); }
  }

  function tbdBox() {
    var S = St(), P = $("panel");
    if (!S || !P || !S.open) return;
    var grid = P.querySelector(".sizeGrid"), st = window.styleById(S.open), old = P.querySelector(".rfTbd");
    if (!grid || !st || !st.sz || st.sz.length < 2) {
      if (old && old.parentNode) old.parentNode.removeChild(old);
      return;
    }
    var sect = grid.closest(".sect") || grid.parentNode, box = old;
    if (!box) {
      box = document.createElement("div");
      box.className = "rfTbd";
      box.innerHTML = '<label class="rfTbdL" for="szTBD"><b>Don&#39;t know sizes yet?</b><span>Enter a total now and send the sizes before we invoice. Priced at the S to XL rate.</span></label>' +
        '<input id="szTBD" type="number" min="0" max="9999" step="1" inputmode="numeric" data-z="' + TBD + '" placeholder="Total" aria-label="Total pieces, sizes to come">';
    }
    if (box.parentNode !== sect || sect.lastElementChild !== box) sect.appendChild(box);
    var inp = box.querySelector("input"), v = S.draft && S.draft[TBD] ? String(S.draft[TBD]) : "";
    if (document.activeElement !== inp && inp.value !== v) inp.value = v;
    inp.classList.toggle("has", !!v);
  }

  function holdLeft(h) {
    var P = $("panel"), L = P && P.querySelector(".pLeft");
    if (!L || !h) return;
    L.style.minHeight = h + "px";
    var seen = false, t0 = Date.now();
    (function check() {
      if (!L.isConnected) return;
      var b = L.querySelector(".rvaThumbs");
      if (b) seen = true;
      if ((b && !b.hidden) || (seen && !b) || L.querySelector(".ssThumbs") || Date.now() - t0 > 1500) {
        L.style.minHeight = "";
        return;
      }
      setTimeout(check, 30);
    })();
  }

  function eachText(st, line, e) {
    var base = window.lineBase(st, line.color, e), parts = [money(base) + " each"];
    ["2XL", "3XL"].forEach(function (z) {
      if (+line.sizes[z] > 0) parts.push(z + " " + money(base + upFor(st, z, line.color)));
    });
    return parts.join(" &middot; ");
  }
  function lineTot(st, line, e) {
    try { return window.lineTotal(st, line.color, line.sizes, e); } catch (x) { return 0; }
  }
  function sizeList(st, line) {
    return (window.SIZES || []).filter(function (z) {
      if (z === TBD) return false;
      return +line.sizes[z] > 0 || hasSize(st, z, line.color);
    });
  }
  function cardHTML(line, n, e) {
    var st = styleOf(line);
    if (!st) return "";
    var u = href(st), q = pcs(line), tbd = +line.sizes[TBD] || 0, name = st.b + " " + st.s;
    var cells = sizeList(st, line).map(function (z) {
      var v = +line.sizes[z] || 0, up = upFor(st, z, line.color);
      return '<label class="rfSz' + (v ? " has" : "") + '" for="rq' + n + z + '"><span class="rfZ">' + esc(z) + (up ? "<em>+" + money(up) + "</em>" : "") + "</span>" +
        '<input id="rq' + n + z + '" type="number" min="0" max="9999" step="1" inputmode="numeric" placeholder="0" data-line="' + n + '" data-lz="' + esc(z) + '" value="' + (v || "") + '"' + (v ? ' class="has"' : "") +
        ' aria-label="' + esc(name + " " + line.color[0] + " " + z) + ' pieces"></label>';
    }).join("");
    var tbdRow = tbd ? '<div class="rfTbdRow"><label for="rq' + n + TBD + '"><b>Sizes to come</b><span>Send these sizes before we invoice. 2XL and up add their upcharge.</span></label>' +
      '<input id="rq' + n + TBD + '" type="number" min="0" max="9999" step="1" inputmode="numeric" placeholder="0" data-line="' + n + '" data-lz="' + TBD + '" value="' + tbd + '" class="has" aria-label="' + esc(name + " " + line.color[0]) + ' pieces, sizes to come"></div>' : "";
    return '<article class="rfCard" id="rfC' + n + '" data-n="' + n + '">' +
      '<div class="rfTop"><a class="rfPic" href="' + u + '" tabindex="-1" aria-hidden="true">' + photo(st, line.color, "phSm") + "</a>" +
      '<div class="rfInfo"><a class="rfName" href="' + u + '"><b>' + esc(name) + "</b> " + esc(st.n) + "</a>" +
      '<span class="rfClr"><span class="rfChip" style="' + esc(window.chipStyle ? window.chipStyle(line.color) : "") + '"></span>' + esc(line.color[0]) + "</span></div>" +
      '<button class="rfRm" type="button" data-rf-rm="' + n + '" aria-label="Remove ' + esc(name + " " + line.color[0]) + '">Remove</button></div>' +
      '<div class="rfSizes" role="group" aria-label="' + esc(name + " " + line.color[0]) + ' pieces by size">' + cells + "</div>" + tbdRow +
      '<div class="rfFoot"><span class="rfQ" id="rfQ' + n + '">' + count(q, "piece", "pieces") + '</span><span class="rfE" id="rfE' + n + '">' + eachText(st, line, e) + '</span><b class="rfT" id="rfT' + n + '">' + money(lineTot(st, line, e)) + "</b></div>" +
      "</article>";
  }
  function listHTML(e) {
    var S = St();
    return '<div class="rfList" id="rfList">' + S.req.map(function (l, n) { return cardHTML(l, n, e); }).join("") +
      '<div class="rfListFoot"><a class="rfMore" href="' + CAT + '">' + ICON_PLUS + "<span>Add another shirt</span></a>" +
      '<div class="rfSub"><span>Subtotal before tax</span><span class="rfSubN"><span id="rTblN">' + e + "</span> pieces</span><b id=\"rTblT\">" + money(window.reqTotal()) + "</b></div></div></div>";
  }
  function emptyHTML() {
    return '<div class="rfEmpty"><h2>Your quote request is empty</h2><p>Open any shirt in the catalog, pick a color and enter how many in each size. It shows up here with a price.</p>' +
      '<a class="btn btn--pri" href="' + CAT + '">Browse the catalog</a>' +
      '<p class="rfEmptyAlt">Already know what you need? <a href="' + PLAIN + '">Send us your art and details</a>.</p></div>';
  }
  function cards() {
    var L = $("rLines"), P = $("reqPage"), S = St();
    if (!L || !S) return;
    var empty = !S.req.length, root = $("rvaCat");
    if (P) P.classList.toggle("rfIsEmpty", empty);
    if (root) root.classList.toggle("rfEmptyReq", empty);
    if (empty) {
      var d = L.querySelector(".rEmpty");
      if (d) d.outerHTML = emptyHTML();
      else if (!L.querySelector(".rfEmpty")) L.innerHTML = emptyHTML();
      return;
    }
    var w = L.querySelector(".rTblWrap");
    if (w) w.outerHTML = listHTML(total());
  }
  function reprice() {
    var S = St(), e = total();
    S.req.forEach(function (line, n) {
      var st = styleOf(line), q = $("rfQ" + n), ea = $("rfE" + n), t = $("rfT" + n);
      if (!st) return;
      if (q) q.textContent = count(pcs(line), "piece", "pieces");
      if (ea) ea.innerHTML = eachText(st, line, e);
      if (t) t.textContent = money(lineTot(st, line, e));
      var c = $("rfC" + n);
      if (c) Array.prototype.forEach.call(c.querySelectorAll(".rfSz"), function (lab) {
        var i = lab.querySelector("input");
        if (i) lab.classList.toggle("has", !!(+line.sizes[i.getAttribute("data-lz")] > 0));
      });
    });
    if (typeof window.rvaF2Note === "function") window.rvaF2Note();
  }

  function onChange(ev) {
    var inp = ev.target && ev.target.closest ? ev.target.closest("input[data-lz]") : null;
    if (!inp || !inp.closest(".rfCard")) return;
    ev.stopPropagation();
    var S = St(), line = S.req[+inp.getAttribute("data-line")];
    if (!line) return;
    if (pcs(line) > 0) return;
    window.dropEmptyLines();
    S.recolor = null;
    window.renderReq();
  }
  function onClick(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest("[data-rf-rm]") : null;
    if (!b) return;
    var S = St(), n = +b.getAttribute("data-rf-rm");
    if (!S.req[n]) return;
    S.req.splice(n, 1);
    S.recolor = null;
    window.renderReq();
    var list = $("rfList");
    if (list) {
      list.setAttribute("tabindex", "-1");
      try { list.focus({ preventScroll: true }); } catch (x) {}
    }
  }

  function ready() {
    var S = St(), Z = window.SIZES;
    return !!S && Array.isArray(Z) && Z.indexOf("XS") >= 0 && ["render", "drawPanel", "lineBase", "lineTotal", "reqPieces", "reqTotal", "saveReq", "styleById", "money"].every(function (k) {
      return typeof window[k] === "function";
    }) && (!isReq() || ["drawLines", "repriceReq", "renderReq", "dropEmptyLines"].every(function (k) {
      return typeof window[k] === "function";
    }));
  }
  function unhide() { document.documentElement.classList.remove("rfWait"); }

  var booted = false;
  function boot() {
    if (booted) return true;
    if (!ready()) return false;
    booted = true;
    try {
      tbdOn();
      patchShare();
      wrap("drawPanel", function (f) {
        return function () {
          var P = $("panel"), L = P && P.querySelector(".pLeft"), h = 0;
          if (L && L.querySelector(".rvaThumbs:not([hidden]), .ssThumbs")) h = L.offsetHeight;
          var r = f.apply(this, arguments);
          try { tbdBox(); } catch (e) { warn(e); }
          try { holdLeft(h); } catch (e) { warn(e); }
          return r;
        };
      });
      if (isReq()) {
        wrap("drawLines", function (f) {
          return function () {
            var a = document.activeElement, L = $("rLines"), id = a && a.id && L && L.contains(a) ? a.id : "";
            var r = f.apply(this, arguments);
            try { cards(); } catch (e) { warn(e); }
            if (id && $(id)) { try { $(id).focus({ preventScroll: true }); } catch (x) {} }
            return r;
          };
        });
        wrap("repriceReq", function (f) {
          return function () {
            var r = f.apply(this, arguments);
            try { reprice(); } catch (e) { warn(e); }
            return r;
          };
        });
        var L = $("rLines");
        if (L) {
          L.addEventListener("change", onChange, true);
          L.addEventListener("click", onClick);
        }
        sharedOnLoad();
        window.render();
      } else if ($("panel") && St().open) tbdBox();
    } catch (e) { warn(e); }
    window.rvaF2Ready = 1;
    unhide();
    return true;
  }

  if (!boot()) {
    var tries = 0, iv = setInterval(function () {
      if (boot() || ++tries > 200) { clearInterval(iv); unhide(); }
    }, 50);
  }
})();